import {
  ApiService,
} from '@/internal';

export default class SurveyService extends ApiService {

  prompt(payload = {}) {

    const {params} = payload;

    return this.request({
      method: 'get',
      url: '/survey/prompt',
      params: this.prepareParams(params),
    });
  }

  viewed(payload = {}) {

    const {params, ...rest} = payload;

    return this.request({
      method: 'post',
      url: '/survey/prompt/viewed',
      params: this.prepareParams(params),
      data: this.preparePayload(rest),
    });
  }

  dismiss(payload = {}) {

    const {params, ...rest} = payload;

    return this.request({
      method: 'post',
      url: '/survey/prompt/dismiss',
      params: this.prepareParams(params),
      data: this.preparePayload(rest),
    });
  }

  submit(payload = {}) {

    const {params, ...rest} = payload;

    return this.request({
      method: 'post',
      url: '/survey/submit',
      params: this.prepareParams(params),
      data: this.preparePayload(rest),
    });
  }
}
